// File: frontend/src/components/IOCTable.tsx
import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Link, alpha } from '@mui/material';
import { cyber } from '../theme';

interface IOC {
    Indicator: string;
    Type: string;
    Description: string;
    "Virus Total URL"?: string; // The key might have spaces
}

interface IOCTableProps {
    iocs: IOC[];
}

const IOCTable: React.FC<IOCTableProps> = ({ iocs }) => {
    if (!iocs || iocs.length === 0) {
        return <p>No Indicators of Compromise found.</p>;
    }

    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="ioc table">
                <TableHead>
                    <TableRow>
                        <TableCell>Indicator</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>VirusTotal Link</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {iocs.map((ioc, index) => (
                        <TableRow key={`${ioc.Indicator}-${index}`}>
                            <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                    fontFamily: cyber.fontMono,
                                    fontSize: '0.8rem',
                                    color: alpha(cyber.accent.cyan, 0.9),
                                    wordBreak: 'break-all',
                                }}
                            >
                                {ioc.Indicator}
                            </TableCell>
                            <TableCell>{ioc.Type}</TableCell>
                            <TableCell>{ioc.Description}</TableCell>
                            <TableCell>
                                {ioc['Virus Total URL'] && ioc['Virus Total URL'].startsWith('http') ? (
                                    <Link href={ioc['Virus Total URL']} target="_blank" rel="noopener noreferrer">
                                        View on VT
                                    </Link>
                                ) : (
                                    'N/A'
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default IOCTable;
